import * as React from 'react';

export const TotalHubViews = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      fill="black"
      d="M6 22.5h12c2 0 3-1 3-3v-7c0-2-1-3-3-3H6c-2 0-3 1-3 3v7c0 2 1 3 3 3Z"
      opacity=".4"
    />
    <path
      fill="#2C3242"
      d="M18 7.25H6a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 0 1.5ZM16 4.25H8a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 0 1.5ZM14.581 15.254l-3.149-1.927a.94.94 0 0 0-1.432.799v3.747a.94.94 0 0 0 1.432.799l3.15-1.927a.873.873 0 0 0 0-1.491Z"
    />
  </svg>
);
